// @flow

import { put, call, takeEvery } from 'redux-saga/effects'
import { uploadToBucket, buckets } from '../../fetch/upload'
import {
  UPLOAD_RANKING_TOOL_IMAGE_START,
  uploadRankingToolImageSuccess,
  uploadRankingToolImageError,
} from '../../stores/pollBuilderCheckedoutPoll'

import { actions as uploadActions } from '.'

export function* uploadThunk(
  bucket: string,
  blob: string,
  description: string,
  dynamicUrl: string
): * {
  yield put(uploadActions.start(bucket, blob, description))
  try {
    const response = yield call(
      uploadToBucket,
      bucket,
      blob,
      description,
      dynamicUrl
    )
    yield put(uploadActions.success(response))
    return response
  } catch (error) {
    yield put(uploadActions.error(error))
    throw error
  }
}

export function* uploadRankingToolOptionImage(): * {
  yield takeEvery(UPLOAD_RANKING_TOOL_IMAGE_START, function*({
    optionId,
    blob,
    description,
  }) {
    try {
      const response = yield call(
        uploadThunk,
        buckets.rankingToolOptions,
        blob,
        description,
        true
      )
      const { url } = response
      yield put(uploadRankingToolImageSuccess(optionId, url))
    } catch (error) {
      yield put(uploadRankingToolImageError(optionId, error))
    }
  })
}



// WEBPACK FOOTER //
// ./src/stores/upload/sagas.js